/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from './customer-details-panel.component';
import * as import3 from '../../orchestration/session.model';
const styles_CustomerDetailsPanelComponent:any[] = ([] as any[]);
export const RenderType_CustomerDetailsPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_CustomerDetailsPanelComponent,
  data: {}
}
);
function View_CustomerDetailsPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'customer-contact-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      '\n    '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.customerDetails.email;
    ck(v,1,0,currVal_0);
  });
}
function View_CustomerDetailsPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'customer-contact-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      '\n    '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.customerDetails.mobilePhone;
    ck(v,1,0,currVal_0);
  });
}
export function View_CustomerDetailsPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'customer'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'customer-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      ' ',
      '\n    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CustomerDetailsPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CustomerDetailsPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import2.CustomerDetailsPanelComponent = v.component;
    const currVal_2:any = co.customerDetails.email;
    ck(v,6,0,currVal_2);
    const currVal_3:any = co.customerDetails.mobilePhone;
    ck(v,9,0,currVal_3);
  },(ck,v) => {
    var co:import2.CustomerDetailsPanelComponent = v.component;
    const currVal_0:any = co.customerDetails.firstName;
    const currVal_1:any = co.customerDetails.lastName;
    ck(v,3,0,currVal_0,currVal_1);
  });
}
function View_CustomerDetailsPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-customer-details-panel',([] as any[]),(null as any),(null as any),(null as any),View_CustomerDetailsPanelComponent_0,RenderType_CustomerDetailsPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import2.CustomerDetailsPanelComponent,[import3.SessionModel],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const CustomerDetailsPanelComponentNgFactory:import0.ComponentFactory<import2.CustomerDetailsPanelComponent> = import0.ɵccf('woa-customer-details-panel',import2.CustomerDetailsPanelComponent,View_CustomerDetailsPanelComponent_Host_0,{customerDetails: 'customerDetails'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/customer-info/customer-details-panel/customer-details-panel.component.ngfactory.ts